import React from "react";
import { Link } from "react-router-dom";
import {
  FileText,
  ArrowLeft
} from "lucide-react";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <header className="border-b sticky top-0 bg-white z-40">
        <div className="max-w-5xl mx-auto px-4 py-4 flex justify-between items-center">
          <img
            src="/marketing/logo_official.png"
            className="h-14"
            alt="OdontoAssist AI"
          />

          <Link
            to="/"
            className="text-indigo-600 flex gap-2 font-semibold"
          >
            <ArrowLeft size={16} />
            Voltar
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-12 space-y-10 [&_p]:text-justify [&_li]:text-justify">

        <div className="flex items-center gap-3 mb-4">
          <FileText className="text-indigo-600" size={30} />
          <h1 className="text-4xl font-black">
            Termos de Uso
          </h1>
        </div>

        <section>
          <h2 className="font-bold text-xl">1. Objeto</h2>
          <p className="leading-relaxed">
            Estes Termos regulam o acesso e uso da plataforma
            OdontoAssist AI, disponibilizada em modelo SaaS para
            gestão clínica odontológica, prontuários eletrônicos, agenda,
            anamnese digital, odontograma, documentos clínicos,
            assinaturas eletrônicas, imagens clínicas,
            suporte com inteligência artificial, Programa de Benefícios,
            integrações, funcionalidades adicionais e demais serviços
            oferecidos pela plataforma.
          </p>
        </section>

        <section>
          <h2 className="font-bold text-xl">2. Licença de uso</h2>
          <p className="leading-relaxed">
            É concedida ao usuário uma licença limitada,
            revogável, não exclusiva, não sublicenciável
            e intransferível para utilização da plataforma
            conforme o plano contratado.
          </p>
        </section>

        <section>
          <h2 className="font-bold text-xl">
            3. Programa de Benefícios e período de teste
          </h2>

          <p className="leading-relaxed">
            O OdontoAssist AI poderá oferecer períodos gratuitos de utilização,
            incluindo teste gratuito, Programa de Benefícios para públicos
            específicos e outras campanhas promocionais.
          </p>

          <p className="leading-relaxed mt-4">
            A concessão desses benefícios está sujeita às regras vigentes,
            podendo depender de análise documental e critérios de elegibilidade.
            Salvo disposição em contrário, benefícios promocionais não são
            cumulativos e poderão ser concedidos apenas uma única vez por usuário.
          </p>

          <p className="leading-relaxed mt-4">
            O OdontoAssist AI poderá criar, alterar, suspender ou
            encerrar programas promocionais, períodos de teste e
            benefícios concedidos a novos usuários, sem prejuízo
            dos benefícios já regularmente concedidos, observadas
            as condições vigentes no momento da concessão.
          </p>          
        </section>

        <section>
          <h2 className="font-bold text-xl">
            4. Responsabilidade profissional
          </h2>

          <p className="leading-relaxed">
            O OdontoAssist AI é ferramenta de apoio operacional
            e documental. A plataforma não substitui
            julgamento clínico, responsabilidade profissional,
            obrigações éticas ou exigências regulatórias do
            cirurgião-dentista.
          </p>
        </section>

        <section>
          <h2 className="font-bold text-xl">
            5. Dados inseridos
          </h2>

          <p className="leading-relaxed">
            O usuário é responsável pela veracidade,
            legitimidade, integridade e base legal dos
            dados inseridos no sistema, incluindo dados
            de pacientes, responsáveis, documentos e
            informações clínicas.
          </p>
        </section>

        <section>
          <h2 className="font-bold text-xl">
            6. Inteligência artificial
          </h2>

          <p className="leading-relaxed">
            Funcionalidades baseadas em inteligência artificial
            fornecem apoio operacional, organização,
            extração de dados e geração de insights,
            não constituindo diagnóstico, prescrição
            ou recomendação clínica definitiva.
            O usuário reconhece que toda decisão clínica,
            prescrição, interpretação de exames, elaboração
            de documentos e conduta profissional permanece
            sob sua exclusiva responsabilidade.            
          </p>
        </section>

        <section>
          <h2 className="font-bold text-xl">
            7. Integrações com serviços de terceiros
          </h2>

          <p className="leading-relaxed">
            O OdontoAssist AI poderá oferecer integrações opcionais com serviços de
            terceiros, como o Google Calendar. A ativação depende de iniciativa e
            autorização do usuário perante o respectivo fornecedor, cujos termos e
            políticas também serão aplicáveis.
          </p>

          <p className="leading-relaxed mt-4">
            Na integração com o Google Calendar, os agendamentos são enviados pelo
            OdontoAssist AI à conta Google conectada e poderão ser atualizados ou
            excluídos para refletir alterações realizadas na plataforma. O usuário
            pode desconectar a conta a qualquer momento em Configurações → Integrações.
          </p>

          <p className="leading-relaxed mt-4">
            A disponibilidade dessas integrações também depende dos serviços, APIs,
            políticas e limites técnicos mantidos pelos respectivos fornecedores. O
            OdontoAssist AI poderá ajustar, suspender ou descontinuar uma integração
            quando necessário por razões técnicas, de segurança, legais ou decorrentes
            de mudanças promovidas pelo terceiro.
          </p>
          <p className="leading-relaxed mt-4">
            Em contas de clínica, cada colaborador deve acessar a plataforma com credencial própria.
            O administrador da clínica é responsável por convidar, revisar, restringir e suspender acessos,
            atribuir perfis compatíveis com as funções exercidas e manter atualizados os vínculos com
            profissionais. É vedado compartilhar senhas ou utilizar a identidade digital de outra pessoa.
          </p>
        </section>

        <section>
          <h2 className="font-bold text-xl">
            8. Assinaturas e pagamentos
          </h2>

          <p className="leading-relaxed">
            A plataforma poderá disponibilizar planos gratuitos,
            períodos promocionais, assinaturas recorrentes e
            módulos adicionais.

            As cobranças poderão ser processadas por provedores
            financeiros integrados, conforme as condições
            comerciais vigentes no momento da contratação.

            Alguns recursos poderão exigir contratação específica,
            como módulos opcionais ou integrações.
          </p>
        </section>

        <section>
          <h2 className="font-bold text-xl">
            9. Cancelamento
          </h2>

          <p className="leading-relaxed">
            O cancelamento poderá ser solicitado a qualquer
            momento. Quando houver cobrança já efetivada,
            o acesso poderá permanecer ativo até o fim do
            ciclo já pago, conforme regras comerciais vigentes.
            O cancelamento não gera restituição automática
            de valores já pagos, salvo quando exigido pela
            legislação aplicável ou previsto em campanhas
            específicas.            
          </p>
        </section>

        <section>
          <h2 className="font-bold text-xl">
            10. Disponibilidade da plataforma
          </h2>

          <p className="leading-relaxed">
            O OdontoAssist AI busca manter elevada disponibilidade,
            podendo realizar manutenções programadas, atualizações
            ou intervenções técnicas necessárias ao funcionamento
            da plataforma.
          </p>
        </section>

        <section>
          <h2 className="font-bold text-xl">
            11. Suspensão ou bloqueio
          </h2>

          <p className="leading-relaxed">
            O OdontoAssist AI poderá suspender ou bloquear
            acessos em caso de inadimplência, uso indevido,
            tentativa de fraude, violação contratual ou
            risco à segurança da plataforma.
          </p>
        </section>

        <section>
          <h2 className="font-bold text-xl">
            12. Proteção de dados
          </h2>

          <p className="leading-relaxed">
            O tratamento de dados pessoais observará a legislação
            aplicável, especialmente a Lei Geral de Proteção de
            Dados (Lei nº 13.709/2018), bem como a Política de
            Privacidade do OdontoAssist AI.
          </p>
        </section>

        <section>
          <h2 className="font-bold text-xl">
            13. Propriedade intelectual
          </h2>

          <p className="leading-relaxed">
            O software, identidade visual, marcas,
            documentação, código, interfaces e demais
            ativos intelectuais permanecem de titularidade
            exclusiva do OdontoAssist AI.
          </p>
        </section>

        <section>
          <h2 className="font-bold text-xl">
            14. Alterações
          </h2>

          <p className="leading-relaxed">
            Estes Termos poderão ser atualizados a qualquer
            momento para refletir alterações legais,
            comerciais, técnicas ou operacionais.
          </p>
        </section>

        <section>
          <h2 className="font-bold text-xl">
            15. Contato
          </h2>

          <p className="leading-relaxed">
            Em caso de dúvidas sobre estes Termos de Uso,
            o usuário poderá entrar em contato com a equipe
            do OdontoAssist AI pelo e-mail
            <strong> suporte@odontoassistai.com.br </strong>
            ou pelo WhatsApp
            <strong> (81) 3204-2969</strong>.
          </p>
        </section>

        <section className="text-sm text-gray-500 border-t pt-6">
          <p>Última atualização: 8 de agosto de 2026.</p>
        </section>

      </main>
    </div>
  );
}
